import React from 'react';
import { Avatar, Button, Divider, makeStyles, Text, tokens } from '@fluentui/react-components';
import { SignOutRegular } from '@fluentui/react-icons';

const useStyles = makeStyles({
  persona: {
    display: 'flex',
    alignItems: 'center',
    columnGap: tokens.spacingHorizontalM,
  },
  identity: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
  },
  // `text-overflow: ellipsis` needs `white-space: nowrap` and clipping on *both* axes —
  // setting only one axis makes the other compute to `auto` and adds a stray scrollbar.
  name: {
    fontWeight: tokens.fontWeightSemibold,
    whiteSpace: 'nowrap',
    overflowX: 'hidden',
    overflowY: 'hidden',
    textOverflow: 'ellipsis',
  },
  email: {
    color: tokens.colorNeutralForeground3,
    whiteSpace: 'nowrap',
    overflowX: 'hidden',
    overflowY: 'hidden',
    textOverflow: 'ellipsis',
  },
  divider: {
    paddingTop: tokens.spacingVerticalL,
    paddingBottom: tokens.spacingVerticalL,
  },
});

interface IStatProfilePanelProps {
  name: string;
  email: string;
  imageUrl?: string;
  onLogOut: () => void;
}

/** Replaces `@coherence-design-system/profile-center`. */
const StatProfilePanel = ({
  name,
  email,
  imageUrl,
  onLogOut,
}: IStatProfilePanelProps): JSX.Element => {
  const styles = useStyles();

  return (
    <div>
      <div className={styles.persona}>
        <Avatar image={{ src: imageUrl }} name={name} color="colorful" size={72} />
        <div className={styles.identity}>
          <Text className={styles.name}>{name}</Text>
          <Text className={styles.email} size={200}>
            {email}
          </Text>
        </div>
      </div>
      <Divider className={styles.divider} />
      <Button appearance="secondary" icon={<SignOutRegular />} onClick={onLogOut}>
        Sign out
      </Button>
    </div>
  );
};

export default StatProfilePanel;
